import React, { createContext, useContext, useState, useEffect } from "react";
import { apiConstants, getGeneric } from "../common/constants";

const DomainConfigContext = createContext({
    domainConfig: null,
    setDomainConfig: () => { },
    loading: false,
});

export const useDomainConfig = () => useContext(DomainConfigContext);

export const DomainConfigProvider = ({ children }) => {
    const [domainConfig, setDomainConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    // fetch config and store in context
    useEffect(() => {
        // In every real deployment the brand is identified by the domain the panel is
        // served on (window.location.origin). To test a specific brand's production
        // config locally, set REACT_APP_BRAND_URL_OVERRIDE in .env.local (gitignored,
        // never shipped) — it is undefined everywhere else, so live traffic is unaffected.
        const brandUrl = process.env.REACT_APP_BRAND_URL_OVERRIDE || window.location.origin;
        if (brandUrl) {
            getGeneric(`${apiConstants.GET_CONFIG_DATA_BY_BRAND}?brandUrl=${brandUrl}`)
                .then((res) => {
                    setDomainConfig(res.data);
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setLoading(false);
                });
        }
    }, []);

    return (
        <DomainConfigContext.Provider value={{ domainConfig, setDomainConfig, loading }}>
            {children}
        </DomainConfigContext.Provider>
    );
}; 